import { createContext, useEffect, useState } from "react";
import clienteAxios from "../config/clienteAxios";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ROLES_CLIENTES } from "../helpers/constants";

const ClientsContext = createContext();

const ClientsProvider = ({ children }) => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const obtenerUsuarios = async () => {
      try {
        const { data } = await clienteAxios.get("/user/getAll");
        setUsers(data.allUsers);
      } catch (error) {
        toast.error("Error al obtener usuarios");
      }
    };
    obtenerUsuarios();
  }, []);

  const forgetPassword = async ({ email, url }) => {
    try {
      const { data } = await clienteAxios.post(`/user/forget-password`, { email, url });
      toast.success(data?.message);
    } catch (error) {
      toast.error("Error al actualizar sección Empresa");
    }
  };

  const changeOldPassword = async (user) => {
    const roleUser = user.role

    try {
      const { data } = await clienteAxios.post(`/user/new-password`, user);
      toast.success(data);
      ROLES_CLIENTES.includes(roleUser) ? navigate('/clientes/login') : navigate('/pgi/login')
    } catch (error) {
      toast.error("Error al actualizar sección Empresa");
    }
  };

  const getUserToChangePassword = async (token) => {
    const { data } = await clienteAxios.get(`/user/change-password/${token}`);
    return data;
  }

  return (
    <ClientsContext.Provider
      value={{
        forgetPassword,
        changeOldPassword,
        getUserToChangePassword,
        users
      }}
    >
      {children}
    </ClientsContext.Provider>
  );
};

export { ClientsProvider };

export default ClientsContext;
